import { UsersApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const usersClient = new UsersApi(ecomConfiguration)
